import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { AllDashboardNotesQuery, AllDashboardNotesQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(AllDashboardNotesQuery)
@Wrapper(AllDashboardNotesQueryHandlerBase)
export class AllDashboardNotesQueryHandler {
    public constructor(
        http: Http
    ) { }
}
